import { BookingStatusEnum, RydeUiUnit } from "@ryde/shared";

/** Result for a single field when building initial values for duplicate form */
export interface IDuplicateFieldEntry {
  skip: boolean;
  value?: unknown;
}

/**
 * Transforms dto for form reset when duplicating.
 */
export const getDtoForDuplicateReset = (
  entity: RydeUiUnit,
  dto: Record<string, unknown>,
  isDuplicate: boolean,
): Record<string, unknown> => {
  if (!isDuplicate) {
    return dto;
  }

  const next = { ...dto };

  if (entity === "booking") {
    if (next.status) {
      next.status = BookingStatusEnum.New;
    }
    delete next.rideId;
    delete next.pickStatus;
  }
  // else if (entity === "ride") { ... }

  return next;
};

/**
 * Patch to apply via setValue before iterating dto.
 */
export const getDuplicateInitialPatch = (
  entity: RydeUiUnit,
  isDuplicate: boolean,
): Record<string, unknown> => {
  if (!isDuplicate) {
    return {};
  }

  if (entity === "booking") {
    return { rideId: undefined, pickStatus: undefined };
  }

  return {};
};

/**
 * For each (field, value) when setting initial values: (skip?, value?).
 */
export const getDuplicateFieldEntry = (
  entity: RydeUiUnit,
  field: string,
  value: unknown,
  isDuplicate: boolean,
): IDuplicateFieldEntry => {
  if (!isDuplicate) {
    return { skip: false };
  }

  if (entity === "booking") {
    if (field === "rideId" || field === "pickStatus") {
      return { skip: true };
    }
    if (
      field === "status" &&
      (value === BookingStatusEnum.Canceled ||
        value === BookingStatusEnum.Routed)
    ) {
      return { skip: false, value: BookingStatusEnum.New };
    }
  }

  return { skip: false };
};

/**
 * Transforms payload before save when duplicating.
 */
export const getPayloadForDuplicateSave = <T extends Record<string, unknown>>(
  entity: RydeUiUnit,
  payload: T,
  isDuplicate: boolean,
): T => {
  if (!isDuplicate) {
    return payload;
  }

  const next = { ...payload } as Record<string, unknown>;

  if (entity === "booking") {
    next.status = BookingStatusEnum.New;
    delete next.rideId;
    delete next.pickStatus;
  }

  return next as T;
};
